<template>
  <!-- 单品方案设计 -->
  <div class="memInfo">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="
        width: 100%;
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      ">
      <el-form :model="addForm" label-position="right" label-width="100px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="单位名称" prop="business">
            <el-input disabled v-model="addForm.business" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户名称">
            <el-input disabled v-model="addForm.name" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="客户性别" prop="sex">
            <el-radio-group v-model="addForm.sex">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
              <el-radio label="">保密</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="联系电话" prop="tel">
            <el-input v-model="addForm.tel" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="会员生日" prop="birthday">
            <el-date-picker
              v-model="addForm.birthday"
              type="date"
              style="width: 200px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="会员生日"
            >
            </el-date-picker>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="会员积分" prop="integral">
            <el-input
              disabled
              v-model="addForm.integral"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="注册日期" prop="registTime">
            <el-date-picker v-model="addForm.registTime" type="date" style="width: 200px" disabled format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" placeholder="注册日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户状态" prop="status">
            <el-radio-group v-model="addForm.status">
              <el-radio label="1">未审核</el-radio>
              <el-radio label="2">已审核</el-radio>
              <el-radio label="0">注销</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="所属机构" prop="entName">
            <el-input disabled v-model="addForm.entName" style="width: 200px;"></el-input>
          </el-form-item>
        </div> -->

        <div class="form-item-wrap">
          <el-form-item label="客户标签" prop="tags" draggable="true">
            <div style="width: 600px">
              <div>
                <el-tag v-for="(item, index) in tagList" :key="index" closable @close="tagClose(index,'tag')"
                  type="success" effect="dark" :disable-transitions="false" class="my-el-tag"
                  style="margin-bottom: 5px">{{ item }}
                </el-tag>
              </div>
              <el-button type="primary" @click="getTagTableData">增加客户标签</el-button>
            </div>
          </el-form-item>
        </div>

        <!-- <div class="form-item-wrap">
          <el-form-item label="经营范围" prop="range">
            <div style="width: 800px">
              <div>
                <el-tag
                  v-for="(item, index) in rangeList"
                  :key="index"
                  closable
                  @close="tagClose(index)"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px"
                  >{{ item }}
                </el-tag>
              </div>
              <el-button type="primary" @click="getTableData"
                >增加经营范围</el-button
              >
            </div>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="type">
            <el-input
              :disabled="true"
              v-model="addForm.type"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="区域" prop="addressData">
            <el-cascader v-model="addForm.addressData" placeholder="选择地址(可搜索)" :options="$store.state.citys"
              :props="{ value: 'value', label: 'label', checkStrictly: true }" style="width: 200px" filterable
              ref="addressSel">
            </el-cascader>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="价格等级" prop="PriceLevel">
            <el-select v-model="addForm.PriceLevel" @change="(val) => handlePriceLevelChange(val)" placeholder="请选择" style="width: 200px">
              <el-option v-if="PriceLevel.length === 0" disabled value="" label="暂无数据" />
              <el-option v-for="(item, index) in PriceLevel" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="addForm.address" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="物流" prop="logisticsCode">
            <el-input v-model="addForm.logisticsName" style="width: 300px" readonly placeholder="请选择"
              @click.native="getLogisticsList('refresh')"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="display: none">
          <el-form-item label="资格证书">
            <el-table :data="seniorityList" tooltip-effect="dark" style="
                width: 700px;
                border: 1px solid #ebeef5;
                border-bottom: none;
              ">
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="name" label="名称">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="img" label="证书">
                <template slot-scope="scope">
                  <img-view :imgList="[{ url: scope.row.img, id: 0 }]"></img-view>
                </template>
              </el-table-column>
              <el-table-column prop="validity" label="效期" align="center">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.validity" type="date" style="width: 140px" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" placeholder="选择效期" @change="setValidity(scope.row)">
                  </el-date-picker>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">保存</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 经营范围数据选择 -->
    <tableDialog v-if="dialogVisible" :title="'经营范围'" :isMoreSel="true" :searchValue="searchForm.name"
      :tableData="tableList" :tableHead="tableDataHead" :currPage.sync="currPage" :allPage="allPage"
      @search="getTableData" @rowClick="rowClick" @moreSel="selDataOk" @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"></tableDialog>

    <!-- 客户标签数据选择 -->
    <tableDialog v-if="tagDialogVisible" :title="'客户标签'" :isMoreSel="true" :searchValue="searchForm.name"
      :tableData="tagTableList" :tableHead="tagTableDataHead" :currPage.sync="tagCurrPage" :allPage="tagAllPage"
      @search="getTagTableData" @rowClick="tagRowClick" @moreSel="selTagDataOk" @hanCurrChange="tagHanCurrChange"
      @close="tagDialogVisible = false"></tableDialog>
    <!-- 物流公司列表 -->
    <el-dialog title="请选择" :visible.sync="logisticsDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="800px">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入名称检索" v-model="logistics"
            @keydown.native.enter="('search')">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getLogisticsList('search')">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="LogisticsList" stripe border tooltip-effect="dark" height="300px">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column align="center" prop="LogisticsName" show-overflow-tooltip label="物流公司">
        </el-table-column>
        <el-table-column align="center" prop="LogisticsCode" show-overflow-tooltip label="编码">
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" style="padding: 2px 3px" plain @click="handleLogisticsItem(scope)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage2" :pageSize="pageSize2" :currIndex="currPage2" @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"></pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "memInfo",
  data() {
    return {
      id: "",
      /**新增表单 */
      addForm: {
        name: "", // 名字
        userName: "", // 客户名称
        sex: "", // 客户性别
        tel: "", // 联系电话
        birthday: "", // 会员生日
        integral: "", // 会员积分
        registTime: "", // 注册日期
        status: "", // 客户状态
        pwd: "", // 密码
        entId: "", // 机构ID
        entName: "", // 所属机构
        business: "", // 所属单位
        range: "", // 经营范围
        tags:'',//客户标签
        type: "", // 客户类型
        addressData: "", // 区域
        address: "", // 地址
        validity: "", // 证书效期
        logisticsCode: "",
        PriceLevel: "", // 价格等级
      },
      /**表单规则 */
      addFormRule: {
        // tel: [mustFill], // 联系电话
        integral: [mustFill], // 会员积分
        registTime: [mustFill], // 注册日期
        status: [mustFill], // 客户状态
        entName: [mustFill], // 所属机构
        business: [mustFill], // 所属单位
        // type: [mustFill], // 客户类型
        // addressData: [mustFill], // 客户类型
      },
      rangeList: [],
      seniorityList: [],
      PriceLevel: [], // 价格等级
      selectedPriceLevel: "", // 选中的价格等级
      areaList: [],
      userList: [],
      ladderList: [
        {
          num: "",
          price: "",
        },
      ],
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      // 表格多选时是否有已选的数据
      isSelDataOkRep: false,
      searchForm: {
        name: "",
      },
      tableList: [],
      tableDataHead: {},

      /**物流公司选择 */
      logistics: "",
      logisticsDialog: false,
      currPage2: 1,
      pageSize2: 20,
      LogisticsList: [],
      allPage2: 0,
      entId: "",
      // 客户标签相关
      tagList: [], // 客户标签列表
      tagDialogVisible: false, // 客户标签弹窗显示控制
      tagTableList: [], // 客户标签表格数据
      tagTableDataHead: {}, // 客户标签表头
      tagCurrPage: 1, // 客户标签当前页
      tagAllPage: 0, // 客户标签总页数
      tagSearchForm: {
      name: "" // 客户标签搜索条件
    },
    isSelTagDataOkRep: false, // 客户标签多选时是否有已选的数据
    };
  },
  mounted() {
    console.log(this.$store.state.citys, "0000000");
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.id) {
      this.id = prams.id;
      this.getUserInfo();
    } else {
      this.getPriceLevel()
    }
    this.entId = window.localStorage.getItem("entId");
    // this.getSeniority()
  },
  computed: {
    priceLevelName() {
      if (!this.addForm.PriceLevel || this.PriceLevel.length === 0) return '';
      const level = this.PriceLevel.find(item => item.value === this.addForm.PriceLevel);
      return level ? level.label : this.addForm.PriceLevel;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取客户详情
    getUserInfo() {
      let data = {
        type: "GetUserInfoDt",
        khId: this.id,
      };
      let proc = "Proc_Admin_MembersQuery"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          console.log(res, "12323");
          if (res.flag == 0) {
            let data = res.data[0];
            console.log('详情',data);
            this.addForm.name = data.name;
            this.addForm.userName = data.username;
            this.addForm.sex = data.sex;
            this.addForm.tel = data.telphone;
            this.addForm.birthday = data.birthday;
            this.addForm.integral = data.point;
            this.addForm.registTime = data.add_time;
            this.addForm.status = data.status;
            this.addForm.pwd = data.password;
            this.addForm.entId = data.entid;
            this.addForm.entName = data.entname;
            this.addForm.business = data.businessname || data.businessname1;
            this.addForm.range = this.$changeStr(data.businesscont);
            this.addForm.tags = data.Tags;
            this.tagList = this.$changeStrArr(data.Tags);
            this.addForm.type = data.clienttype;
            this.addForm.addressData = data.quyuflbh;

            if (this.addForm.addressData.length == 2) {
              this.addForm.addressData;
            } else if (this.addForm.addressData.length == 4) {
              this.addForm.addressData;
            }
            this.addForm.address = data.address;
            this.rangeList = this.$changeStrArr(data.businesscont);
            this.addForm.PriceLevel = data.shortname;
            this.selectedPriceLevel = data.shortname;
            this.getPriceLevel(); //获取价格等级列表
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
     /** 获取区域 */
     getPriceLevel(selectedValue) {
      console.log('请求区域数据，选中值:', selectedValue);
      let data = {
        entId: window.localStorage.getItem("entId"),
        sqlValue: "",
        pageIndex: 1,
        pageSize: 15,
      };
      this.$request({
        method: "post",
        url: "GoodsAdmin/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          // console.log('获取区域999', res);
          if (res.success) {
            this.PriceLevel = (res.list || []).map((item) => ({
              label: item.PriceName, // 区域编号
              value: item.PriceCode, // 区域名称
            }));
            if (this.selectedPriceLevel) {
              const exists = this.PriceLevel.some(item => item.value === this.selectedPriceLevel);
              if (!exists) {
                // 如果编码不在列表中，尝试使用名称匹配
                const matchByName = this.PriceLevel.find(item => item.label === this.selectedPriceLevel);
                if (matchByName) {
                  this.addForm.PriceLevel = matchByName.value;
                } else {
                  // 如果都匹配不上，保持原值，但可能需要提示用户
                  console.warn('价格等级编码不在列表中:', this.selectedPriceLevel);
                }
              }
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 区域显示文字处理
    // formatPriceLevel(row) {
    //   const priceLevel = this.PriceLevel.find(item => item.value === row.PriceLevel);
    //   return priceLevel ? priceLevel.label : row.PriceLevel;
    // },
   
    // 获取资质列表
    getSeniority() {
      let data = {
        userId: this.id,
      };
      this.$request({
        method: "post",
        url: "Member/GetMemberMaterial",
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.seniorityList = res.list.map((item) => ({
            id: item.id,
            name: item.materialName,
            img: this.$setImgUrl(item.materialUrl),
            validity: item.valdate,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 获取弹出框表格数据
    getTableData(val, isRep) {
      this.searchForm.name = isRep ? val : this.searchForm.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        pageIndex: this.currPage,
        pageSize: 10,
        sqlValue: this.searchForm.name,
        channel_id: 12,
        keyId: 0,
      };
      this.$request({
        method: "post",
        url: "Base/GetTableCategory",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableList = res.list;
            this.tableDataHead = {
              Id: "编号",
              entId: "机构编号",
              title: "名称",
              sort_id: "排序",
            };
            this.allPage = res.toTal;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    setValidity(row) {
      let data = {
        id: row.id,
        valdate: row.validity,
      };
      this.$request({
        method: "post",
        url: "Member/UpdateMemberMaterialValdate",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择单条数据
    rowClick(row, isSelDataOk) {
      for (let i = 0; i < this.rangeList.length; i++) {
        if (this.rangeList[i] == row.title) {
          if (isSelDataOk === true) {
            this.isSelDataOkRep = true;
          } else {
            this.$message({
              message: "选择的数据已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.rangeList.push(row.title);
      this.addForm.range = this.rangeList.join();
      this.dialogVisible = false;
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.rowClick(item, true);
      });
      if (this.isSelDataOkRep) {
        this.$message({
          message: "选择的数据已在列表中",
          type: "warning",
        });
        this.isSelDataOkRep = false;
      }
    },
    // 标签删除
    tagClose(index,type) {
      if(type == 'tag') {
        this.tagList.splice(index, 1);
        this.addForm.tags = this.tagList.join();
      } else {
        // 经营范围的处理
        this.rangeList.splice(index, 1);
        this.addForm.range = this.rangeList.join();
      }
      
    },
    // 获取客户标签表格数据
    getTagTableData(val,isRep) {
      this.tagSearchForm.name = isRep ? val : this.tagSearchForm.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        id: 33,
        channel_id: 21, //客户标签
        title: '',
        parent_id: '',
        class_layer: '',
        sort_id: '',
        link_url: '',
        img_url: '',
        pageIndex: this.tagCurrPage,
        pageSize: 20,
        toTal: '',
        sqlValue: this.tagSearchForm.name,
        keyId: 0,
      };
      this.$request({
        method: "post",
        url: "Base/GetTableCategory",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tagTableList = res.list;
            this.tagTableDataHead = {
              Id: "编号",
              entId: "机构编号",
              title: "名称",
              sort_id: "排序",
            };
            this.tagAllPage = res.toTal;
            this.tagDialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });

    },
    // 客户标签当前页改变
    tagHanCurrChange(val) {
      this.tagCurrPage = val;
      this.getTagTableData()
    },
    // 选择客户标签单条数据
    tagRowClick(row, isSelDataOk) {
      for (let i = 0; i < this.tagList.length; i++) {
        if (this.tagList[i] == row.title) {
          if (isSelDataOk === true) {
            this.isSelTagDataOkRep = true;
          } else {
            this.$message({
              message: "选择的标签已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.tagList.push(row.title);
      this.addForm.tags = this.tagList.join();
      this.tagDialogVisible = false;
    },
    // 选择客户标签数据完成，多选
    selTagDataOk(selectedList) {
      if(selectedList.length == 0) {
        this.$message({
          message: "请选择标签",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.tagRowClick(item, true);
      });
      if (this.isSelTagDataOkRep) {
        this.$message({
          message: "选择的标签已在列表中",
          type: "warning",
        });
        this.isSelTagDataOkRep = false;
      }
    },
    // 根据地址获取经纬度
    getAddress() {
      window.AMap.plugin("AMap.Geocoder", () => {
        let geocoder = new window.AMap.Geocoder({});
        geocoder.getLocation(this.addForm.address, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            this.$request({
              method: "post",
              url: "Business/MaintainLngAndLat",
              data: {
                entId: window.localStorage.getItem("entId"),
                businessId: this.id,
                lng: result.geocodes[0].location.lng,
                lat: result.geocodes[0].location.lat,
              },
            })
              .then((res) => {
                console.log(res);
              })
              .catch((err) => {
                window.console.log(err);
              });
          }
        });
      });
    },
    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (this.addForm.address) {
            this.getAddress();
          }
          let addresData = this.$refs.addressSel.getCheckedNodes()[0] || {};
          // let data = {
          //   type: "UpdateUserInfo",
          //   userName: this.addForm.userName,
          //   name: this.addForm.name,
          //   sex: this.addForm.sex,
          //   telphone: this.addForm.tel,
          //   birthday: this.addForm.birthday,
          //   point: this.addForm.integral,
          //   status: this.addForm.status,
          //   entId: this.addForm.entId,
          //   businessName: this.addForm.business,
          //   businessId: this.id,
          //   userId: this.id,
          //   businesscont: this.addForm.range,
          //   province: (addresData.pathLabels && addresData.pathLabels[0]) || "",
          //   city: (addresData.pathLabels && addresData.pathLabels[1]) || "",
          //   area: (addresData.pathLabels && addresData.pathLabels[2]) || "",
          //   areaCode: addresData.value || "",
          //   address: this.addForm.address,
          //   county: (addresData.pathLabels && addresData.pathLabels[2]) || "",
          //   quyuflbh: addresData.value || "",
          //   logisticsCode: this.addForm.logisticsCode,
          // };
          let data = {
            UserId: this.id,
            Province: (addresData.pathLabels && addresData.pathLabels[0]) || "",
            City: (addresData.pathLabels && addresData.pathLabels[1]) || "",
            Area: (addresData.pathLabels && addresData.pathLabels[2]) || "",
            AreaCode: addresData.value || "",
            Address: this.addForm.address,
            BusinessCont: this.addForm.range,        
            TelPhone: this.addForm.tel,
            LogisticsCode: this.addForm.logisticsCode,
            Tags:this.addForm.tags, //客户标签
            PriceLevel: this.addForm.PriceLevel, // 价格等级
          };
          this.$request({
            method: "post",
            url: "Management/MemberAdmin/EditBusinessDoc",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
          // let proc = ""; //存储过程名
          // let type = "UpdateUserInfo";
          // /Management/MemberAdmin/EditBusinessDoc
          //   this.$requestSys({
          //     method: "post",
          //     url:
          //       "members/ashx/ReturnJson.ashx?type=" +
          //       type +
          //       "&json=" +
          //       encodeURIComponent(JSON.stringify(data)) +
          //       "&proc=" +
          //       proc,
          //   })
          //     .then((res) => {
          //       if (res.flag == 0) {
          //         this.$message({
          //           message: "操作成功",
          //           type: "success",
          //         });
          //         this.goBack();
          //       } else {
          //         this.$message({
          //           message: res.message,
          //           type: "error",
          //         });
          //       }
          //     })
          //     .catch((err) => {
          //       window.console.log(err);
          //     });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },

    /**获取物流公司 */
    getLogisticsList(type = "") {
      this.logisticsDialog = true;

      //函数太多 type: refresh search 不传参数默认加载
      if (type == "refresh") {
        this.currPage2 = 1;
        this.logistics = "";
      } else if (type == "search") {
        this.currPage2 = 1;
      }

      let data = {
        entId: this.entId,
        searchVal: this.logistics,
        status: "Y", //Y启用，N禁用
        pageIndex: this.currPage2,
        pageSize: this.pageSize2,
      };

      this.$request({
        url: "Base/LogisticsList",
        method: "post",
        data,
      })
        .then((res) => {
          this.LogisticsList = res.list;
          this.allPage2 = res.toTal;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getLogisticsList();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getLogisticsList();
    },

    /**选中某一个物流 */
    handleLogisticsItem({ row }) {
      this.logisticsDialog = false;
      this.addForm.logisticsName = row.LogisticsName;
      this.addForm.logisticsCode = row.LogisticsCode;
    },
  },
};
</script>

<style scoped>
.memInfo {
  width: 100%;
  height: 100%;
}
</style>